import { YardReportDateType } from '@/core/domain/visual-management/yard-report/yard-report.enums';
import { Form, Radio, Typography } from 'antd';

export default function YardManagementReportDateFilter() {
  const options = [
    { value: YardReportDateType.EntryDate, label: 'Entrada' },
    { value: YardReportDateType.EstimateLeaveDate, label: 'Entrega' },
  ];

  return (
    <>
      <Typography.Title level={5}>Filtrar por data de</Typography.Title>

      <Form.Item
        name="dateFilter"
        initialValue={YardReportDateType.EntryDate}
        noStyle
      >
        <Radio.Group optionType="button" buttonStyle="solid" size="large">
          {options.map((option) => (
            <Radio key={option.value} value={option.value}>
              {option.label}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </>
  );
}
